import {CONSTANTS} from '../../../constants'
import {apiGet, apiPost} from '../../api'
import {PushClientDTO} from 'grilnica-store-share'

async function loadPushMessagesService(cityId: string): Promise<PushClientDTO[]> {
  try {
    return await apiGet(CONSTANTS.apiStoreUrl + '/push-queue/client/all', {
      cityId: cityId,
    })
  } catch (error) {
    console.error('Error loadPushMessagesService error', error)
  }
}

async function readPushMessageService(pushQueueId: string, cityId: string): Promise<void> {
  return await apiPost(
    CONSTANTS.apiStoreUrl + '/push-queue/client/read',
    {pushQueueId},
    {
      cityId: cityId,
    },
  )
}

async function hidePushMessageService(pushQueueId: string, cityId: string): Promise<void> {
  return await apiPost(
    CONSTANTS.apiStoreUrl + '/push-queue/client/hide',
    {pushQueueId},
    {
      cityId: cityId,
    },
  )
}

export {loadPushMessagesService, readPushMessageService, hidePushMessageService}
